import { render, staticRenderFns } from "./HelpWidget.vue?vue&type=template&id=5d066774&scoped=true"
import script from "./HelpWidget.vue?vue&type=script&lang=js"
export * from "./HelpWidget.vue?vue&type=script&lang=js"
import style0 from "./HelpWidget.vue?vue&type=style&index=0&id=5d066774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d066774",
  null
  
)

export default component.exports